/**
 * Border shorthand tokens.
 *
 * Combined border tokens encode the default width and style pair used by the
 * first-release toolkit contract.
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const borders = Object.freeze({
    xs: '0.5px solid',
    sm: '1px solid',
    md: '2px solid',
    lg: '4px solid',
    xl: '8px solid',
});
const BORDER_TOKEN_SET = new Set(Object.keys(borders));
export function isBorderToken(value) {
    return BORDER_TOKEN_SET.has(value);
}
export const BORDER_TOKEN_KEYS = Object.freeze(Object.keys(borders).sort());
//# sourceMappingURL=borders.js.map